import ComingSoonPage from "../../components/ComingSoonPage";
import AppShell from '../../components/AppShell';

export default function TrendPulse() {
  return (
    <AppShell>
      <div className="lg:col-span-8 space-y-6 text-center">
    <ComingSoonPage
      appName="Trend Pulse AI"
      teaser="Spot market shifts with AI-powered social and search trend analysis."
      imageSrc="/images/coming-soon/trendpulse.png"
    />
    </div>
    </AppShell>
  );
}

